import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxSelectModule, RxUiModule } from '@nrwl/rx-ui';

import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgModule } from '@angular/core';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxDatepickerModule } from '@nrwl/rx-datepicker';
import { RxDatepickerWithInputModule } from '@nrwl/rx-datepicker-with-input';
import { RxExpansionPanelModule } from '@nrwl/rx-expansion-panel';
import { RxFileUploadModule } from '../rx-file-upload/rx-file-upload.module';
import { RxFormBuilderModule } from '@nrwl/rx-form-builder';
import { RxFormControlErrorsModule } from '@nrwl/rx-form-errors';
import { RxFormUploadComponent } from './rx-form-upload/rx-form-upload.component';
import { RxCreateFormDialogComponent } from './rx-create-form-dialog/rx-create-form-dialog.component';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxSplitViewModule } from '@nrwl/rx-split-view';
import { RxTabsModule } from '@nrwl/rx-tabs';
import { RxTipModule } from '@nrwl/rx-tip';
import { RxUploadBrandedComponent } from './rx-upload-branded/rx-upload-branded.component';
import { RxUploadPdfFormComponent } from './rx-upload-pdf-form/rx-upload-pdf-form.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxUiModule,
    RxFormControlErrorsModule,
    MatExpansionModule,
    DragDropModule,
    RxButtonModule,
    RxIconModule,
    RxFormBuilderModule,
    RxExpansionPanelModule,
    RxSplitViewModule,
    RxTabsModule,
    RxTipModule,
    RxFileUploadModule,
    RxDatepickerModule,
    RxDatepickerWithInputModule,
    RxSelectModule,
    RxFormUploadComponent,
    RxUploadBrandedComponent,
    RxCreateFormDialogComponent,
    RxUploadPdfFormComponent,
  ],
  exports: [
    RxFormUploadComponent,
    RxUploadBrandedComponent,
    RxCreateFormDialogComponent,
    RxUploadPdfFormComponent,
  ],
})
export class RxFormsModule {}
